// This icon file is generated automatically.
var PShareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.75 8.38c-.45 0-.86.15-1.18.41L5.33 6.45a2.51 2.51 0 000-.9l3.24-2.34a1.88 1.88 0 10-.62-.94L4.87 4.5a2.5 2.5 0 100 3l3.08 2.23a1.88 1.88 0 101.8-1.35zm0-7.44a.81.81 0 110 1.62.81.81 0 010-1.62zM2.87 7.38a1.38 1.38 0 110-2.76 1.38 1.38 0 010 2.75zm6.88 3.68a.81.81 0 110-1.62.81.81 0 010 1.62z", "fill-rule": "nonzero" } }] }, "name": "p-share", "theme": "outlined" };
export default PShareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PShareOutlined.js
// module id = 3624
// module chunks = 0